import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowsRotate,
  faCircleCheck,
  faCircleXmark,
  faMoneyBillWave,
  faPaperPlane,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

export type TableHeading = {
  header: string;
  accessor: string;
  /** Column alignment — defaults to left. */
  align?: "left" | "center" | "right";
};

export const chaseHeadingData: TableHeading[] = [
  {
    header: "CUSTOMER NAME",
    accessor: "customerName",
  },
  {
    header: "CONTACT DETAILS",
    accessor: "contactDetails",
  },
  {
    header: "DATES",
    accessor: "type",
  },
  {
    header: "AMOUNT",
    accessor: "amount",
    align: "center",
  },
  {
    header: "TYPE",
    accessor: "",
    align: "center",
  },
  {
    header: "STATUS",
    accessor: "status",
  },
  {
    header: "",
    accessor: "types",
  },
  {
    header: "ACTIONS",
    accessor: "actions",
  },
];

export const branddata = [
  {
    name: "CCD",
    label: "Car Compare Direct",
  },
  {
    name: "CLD",
    label: "Car LineDirect",
  },
  {
    name: "VLD",
    label: "Van LineDirect",
  },
  {
    name: "VCD",
    label: "VanCompare Direct",
  },
  {
    name: "VI",
    label: "Van Insurance UK",
  },
];

export const brandCodes = [
  { value: "BICX", label: "VanInsurance.co.uk" },
  { value: "BIKI", label: "BikeInsurance.co.uk" },
  { value: "BCOM", label: "BikeCompareDirect" },
  { value: "BLD", label: "BikelineDirect" },
  { value: "BUSC", label: "BusinessCompare" },
  { value: "BACT", label: "BusinessCompare(Acturis)" },
  { value: "BOGI", label: "BusinessCompare(OGI)" },
  { value: "CARI", label: "CarInsurance.co.uk" },
  { value: "CCOM", label: "CarCompareDirect" },
  { value: "CCOT", label: "CarCompareDirect" },
  { value: "CLD", label: "CarlineDirect" },
  { value: "CLDT", label: "CarlineDirect" },
  { value: "CLDX", label: "CarlineDirect" },
  { value: "CRC", label: "CourierCompare" },
  { value: "CRCT", label: "CourierCompare" },
  { value: "CVAI", label: "VanInsurance.co.uk" },
  { value: "CVCT", label: "VanCompareDirect" },
  { value: "CVLT", label: "VanlineDirect" },
  { value: "HCOM", label: "HomeCompareDirect" },
  { value: "HLD", label: "HomelineDirect" },
  { value: "NCAR", label: "CarCompareDirect" },
  { value: "NCLD", label: "CarlineDirect" },
  { value: "NCOM", label: "VanCompareDirect" },
  { value: "NVAI", label: "VanInsurance.co.uk" },
  { value: "NVLD", label: "VanlineDirect" },
  { value: "SBIZ", label: "SimplyBusiness" },
  { value: "VANI", label: "VanInsurance.co.uk" },
  { value: "VANL", label: "VanInsurance.co.uk" },
  { value: "VANT", label: "VanInsurance.co.uk" },
  { value: "VCOL", label: "VanCompareDirect" },
  { value: "VCOM", label: "VanCompareDirect" },
  { value: "VCOT", label: "VanCompareDirect" },
  { value: "VICC", label: "VanInsurance.co.uk" },
  { value: "VICN", label: "VanInsurance.co.uk" },
  { value: "VICX", label: "VanInsurance.co.uk" },
  { value: "VLD", label: "VanlineDirect" },
  { value: "VLDC", label: "VanlineDirect" },
  { value: "VLDT", label: "VanlineDirect" },
  { value: "VLDV", label: "VanlineDirect" },
  { value: "VLDW", label: "VanlineDirect" },
  { value: "VLDX", label: "VanlineDirect" },
];

export type LoanStatusRow = {
  name: string;
  bgColor: string;
  icon: IconDefinition;
  color: string;
};

export const loanStatusData: LoanStatusRow[] = [
  {
    name: "Auto-Renewals",
    bgColor: "bg-blue-50 dark:bg-blue-500/15",
    icon: faArrowsRotate,
    color: "text-blue-800 dark:text-blue-300",
  },
  {
    name: "Inviting",
    bgColor: "bg-indigo-50 dark:bg-indigo-500/15",
    icon: faPaperPlane,
    color: "text-indigo-700 dark:text-indigo-300",
  },
  {
    name: "Payment-Received",
    bgColor: "bg-indigo-50 dark:bg-indigo-500/15",
    icon: faMoneyBillWave,
    color: "text-indigo-700 dark:text-indigo-300",
  },
  {
    name: "Renewed",
    bgColor: "bg-emerald-50 dark:bg-emerald-500/15",
    icon: faCircleCheck,
    color: "text-emerald-800 dark:text-emerald-300",
  },
  {
    name: "Payment-Failed",
    bgColor: "bg-amber-50 dark:bg-amber-500/15",
    icon: faTriangleExclamation,
    color: "text-amber-800 dark:text-amber-300",
  },
  {
    name: "Lapsed",
    bgColor: "bg-slate-100 dark:bg-slate-500/15",
    icon: faCircleXmark,
    color: "text-slate-700 dark:text-slate-300",
  },
];
